import 'css-chunksrc/client/scenes/projectPortfolioCreation/form/projectSelection/styles.scss';export default {
  "input": "_input_1jmn4_1",
  "opened": "_opened_1jmn4_13",
  "toggleArrow": "_toggleArrow_1jmn4_17",
  "name": "_name_1jmn4_21",
  "placeholder": "_placeholder_1jmn4_29",
  "selectedProjects": "_selectedProjects_1jmn4_34",
  "selectedProject": "_selectedProject_1jmn4_34",
  "listRoot": "_listRoot_1jmn4_59",
  "list": "_list_1jmn4_59",
  "item": "_item_1jmn4_77",
  "project": "_project_1jmn4_88",
  "selected": "_selected_1jmn4_34",
  "folderIcon": "_folderIcon_1jmn4_97"
};